export default __webpack_public_path__ + "static/media/Chef-2.f2dd25ac.jpg";